import type { FirebaseOptions } from "firebase/app";
import configFile from "./config.json";

export const config = configFile as unknown as WebWidgetsConfig;

export type WebWidgetsAuthConfig =
	| {
			strategy: "credentials";
			tenantId: never;
	  }
	| {
			strategy: "adfs";
			tenantId: string;
	  };

/**
 * The configuration structure passed to the Web Widgets. This structure holds all
 * data required to customize this instance, and alter the way it behaves.
 */
export interface WebWidgetsConfig {
	/**
	 * The specific endpoint used for deep linking
	 */
	deepLinkEndpoint: string;

	/**
	 * Dashboard locale configuration
	 */
	locales: {
		default: string;
		list: Record<string, string>;
	};

	/**
	 * The connected App Platform instance details
	 */
	platform?: {
		endpoint: string;
	};

	/**
	 * The config for each module in the dashboard
	 *
	 * @example
	 * {
	 * 	"module-id": {
	 * 		"key": "value" | true | false | 0 | 1
	 * 	}
	 * }
	 */
	moduleConfig?: Record<string, Record<string, any>>;

	/**
	 * The versions used for each module
	 */
	moduleVersions?: Record<string, string>;

	/**
	 * firebase configuration
	 */
	firebase?: Pick<FirebaseOptions, "apiKey" | "authDomain" | "projectId" | "appId"> | null;

	/**
	 *
	 */
	auth?: WebWidgetsAuthConfig | null;
}
